var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-grid',[_c('sui-grid-row',[_c('sui-grid-column',[_c('highcharts',{attrs:{"options":_vm.options}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }